import { createStore } from '@/src/hooks/store/createStore';

interface AudioState {
  audio?: HTMLAudioElement;
  setAudio: (loading: HTMLAudioElement | undefined) => void;
  isPlaying?: boolean;
}

export const useAudio = createStore<AudioState>(null, (set, get) => ({
  audio: undefined,
  setAudio: (audio) => {
    if (get().isPlaying) {
      return;
    }

    if (audio) {
      audio.onplay = () => set({ isPlaying: true });
      audio.onpause = () => set({ isPlaying: false });
    }

    set({ audio });
  },
}));
